export var valuesLegendVerticalAlignment = ["top", "middle", "bottom"];
//# sourceMappingURL=LegendVerticalAlignment.js.map